export default __webpack_public_path__ + "media/images/home/en/preview-2-6793c69381c1891a307dd712b9b6d9ba.jpg";